const unitTypes = [
  { text: 'Undergraduate', value: 'Undergraduate' },
  { text: 'Postgraduate', value: 'Postgraduate' },
];

export default unitTypes;
